import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'
import AutoAwesomeRoundedIcon from '@mui/icons-material/AutoAwesomeRounded'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
import { openWithEntity } from 'ducks/guruWidget/actions'

const seen = key => {
  try { return window.localStorage.getItem(key) === '1' } catch { return false }
}
const markSeen = key => {
  try { window.localStorage.setItem(key, '1') } catch { /* private mode */ }
}

const GuruTip = ({ storageKey, noun = 'item', prompt = '' }) => {
  const dispatch = useDispatch()
  const [open, setOpen] = useState(() => !seen(storageKey))
  if (!open) return null

  const dismiss = () => { markSeen(storageKey); setOpen(false) }
  const ask = () => dispatch(openWithEntity({ initialView: 'chat', prefilledInput: prompt }))

  return (
    <Wrap role='note'>
      <IconTile><AutoAwesomeRoundedIcon style={{ fontSize: 18 }} /></IconTile>
      <Body>
        <strong>Let Guru do it for you.</strong> Describe the {noun} in plain English and Guru creates
        it, checking for duplicates first, so nothing gets logged twice.
      </Body>
      <AskBtn type='button' onClick={ask}>
        <AutoAwesomeRoundedIcon style={{ fontSize: 15 }} /> Ask Guru
      </AskBtn>
      <Close type='button' aria-label='Dismiss' onClick={dismiss}>
        <CloseRoundedIcon style={{ fontSize: 16 }} />
      </Close>
    </Wrap>
  )
}

export default GuruTip

const ACCENT = '#33becc'
const ACCENT_HOVER = '#2aa6b3'

const Wrap = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 11px 14px;
  margin-bottom: 16px;
  border-radius: 12px;
  background: #e6f7f9;
  border: 1px solid rgba(51, 190, 204, 0.3);
`

const IconTile = styled.span`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 9px;
  color: ${ACCENT_HOVER};
  background: rgba(51, 190, 204, 0.14);
`

const Body = styled.div`
  flex: 1;
  min-width: 0;
  font-size: 12.5px;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.grey[800]};
  strong { color: ${({ theme }) => theme.colors.haiti}; }
`

const AskBtn = styled.button`
  font: inherit;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  min-height: 40px;
  padding: 8px 16px;
  border-radius: 999px;
  border: none;
  background: ${ACCENT};
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: background-color 150ms ease;
  &:hover { background: ${ACCENT_HOVER}; }
`

const Close = styled.button`
  font: inherit;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: none;
  background: transparent;
  color: ${({ theme }) => theme.colors.grey[800]};
  border-radius: 7px;
  opacity: 0.6;
  cursor: pointer;
  &:hover { opacity: 1; background: rgba(12, 18, 41, 0.05); }
`
